import { Toggle } from '@/platform/ui';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { router, usePage } from '@inertiajs/react';

const ToggleActive = ({ invitee }) => {
    const { auth } = usePage().props;

    const toggleActive = () => {
        router.patch(
            `/customers/${invitee.customer_id}/datahub-invitees/${invitee.id}`,
            {
                ...invitee,
                active: !invitee.active,
            }
        );
    };

    if (auth.permissions?.includes('update datahub invitees')) {
        return <Toggle checked={invitee.active} onChange={toggleActive} />;
    }

    if (invitee.active) {
        return <CheckIcon className='inline-flex size-5 text-green-600' />;
    }

    return <XMarkIcon className='inline-flex size-5 text-red-600' />;
};

export default ToggleActive;
